export interface SystemConfig {
  id: number
  key: string
  value: string
  description: string
  updated_at: string
}

export interface ConfigItem {
  key: string
  value: string
}

export interface ConfigUpdateRequest {
  configs: ConfigItem[]
}

export const SystemConfigKey = {
  SMTP_HOST: 'smtp_host',
  SMTP_PORT: 'smtp_port',
  SMTP_USER: 'smtp_user',
  SMTP_PASS: 'smtp_pass',
  NOTIFY_TO: 'notify_to',
  FTP_HOST: 'ftp_host',
  PUBLIC_BASE_URL: 'public_base_url',
  PA_EMBEDDING_PROVIDER: 'pa_embedding_provider',
  UGC_MAIL_BATCH_LIMIT: 'ugc_mail_batch_limit',
  UGC_MAIL_INTERVAL_MINUTES: 'ugc_mail_interval_minutes',
  UGC_MAIL_WINDOW_START: 'ugc_mail_window_start',
  UGC_MAIL_WINDOW_END: 'ugc_mail_window_end'
} as const

export type SystemConfigKey = (typeof SystemConfigKey)[keyof typeof SystemConfigKey]

// AI モデル設定（SMART_HUB_DEV-159）。選択肢・プロダクト・既定値は API（/api/system-config/ai-models）が正
export const AiModelTier = {
  STANDARD: 'standard',
  LIGHT: 'light'
} as const

export type AiModelTier = (typeof AiModelTier)[keyof typeof AiModelTier]

/** 設定キーの接頭辞。キーは ai_model.<プロダクト>.<standard|light> */
export const AI_MODEL_CONFIG_KEY_PREFIX = 'ai_model.'

export const aiModelConfigKey = (product: string, tier: AiModelTier) =>
  `${AI_MODEL_CONFIG_KEY_PREFIX}${product}.${tier}`

/** 選べる AI モデル */
export interface AiModel {
  id: string
  label: string
  tiers: AiModelTier[]
  input_usd_per_mtok: number
  output_usd_per_mtok: number
  note: string
}

/** モデルを選ぶ単位（プロダクト）。uses に無い枠はそのプロダクトでは使っていない */
export interface AiProduct {
  key: string
  label: string
  uses: Partial<Record<AiModelTier, string>>
  current: Partial<Record<AiModelTier, string>>
}

export interface AiModelCatalog {
  models: AiModel[]
  products: AiProduct[]
  defaults: Record<AiModelTier, string>
  tier_labels: Record<AiModelTier, string>
}
